import * as Swiper from "../libs/swiper";

export function arrowSlider() {
    $(window).on("load", function () {
        const slider = $(".arrow-slider");

        const sliderSettings = {
            slidesPerView: "1",
            spaceBetween: 40,
            watchOverflow: true,
            autoHeight: true,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
        };

        const mySwiper = new Swiper(slider, sliderSettings);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/arrow-slider.js